export interface NewsItem {
  id: string;
  title: string;
  summary: string;
  cover: string;
  date: string;
  category: string;
  author: string;
  source: string;
  hot: number;
  body: string[];
}

export interface ResourceItem {
  id: string;
  name: string;
  cover: string;
  type: "film" | "game" | "comic";
  typeLabel: string;
  tags: string[];
  region: string;
  year: number;
  rating: number;
  favorites: number;
  summary: string;
  body: string[];
}

export interface TopicItem {
  id: string;
  title: string;
  summary: string;
  tags: string[];
  replies: number;
  views: number;
  date: string;
  author: string;
  body: string[];
}

export interface SlideItem {
  id: string;
  detailId: string;
  kicker: string;
  title: string;
  description: string;
  image: string;
  tag: string;
}

export const newsList: NewsItem[] = [
  {
    id: "n1",
    title: "《暗涌》上线：心理惊悚题材的成人向剧集如何拍出克制感",
    summary:
      "一部只有八集的剧集，用大量留白和雨夜光影讲完一段危险关系。主创在采访中谈到，真正让观众紧张的从来不是画面，而是人物之间没有说出口的部分。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20noir%20still%20of%20a%20rainy%20city%20street%20at%20night%20reflected%20in%20wet%20asphalt%2C%20deep%20wine%20red%20neon%20glow%2C%20mysterious%20elegant%20atmosphere%2C%20artistic%20poster%20photography%2C%20no%20people&width=640&height=400&seq=news-cover-01&orientation=landscape",
    date: "2026-10-12",
    category: "影视资讯",
    author: "编辑部 · 顾青",
    source: "18禁影视观察",
    hot: 9820,
    body: [
      "《暗涌》在上周末一次性放出全季八集，很快成为本站本周讨论度最高的剧集。故事设定在一座常年下雨的港城，两位主角因为一桩旧案重新产生交集，剧情几乎全部发生在夜间的室内空间里。",
      "导演在采访中提到，剧组刻意放弃了强情绪的镜头语言，把大量篇幅交给窗外的雨声、走廊的脚步声和两人之间漫长的沉默。这种处理方式让整部剧的紧张感来自观众自己的推测，而不是画面直接给出的信息。",
      "从类型上看，《暗涌》更接近心理惊悚，而不是传统意义上的成人向作品。剧中的亲密场面篇幅极少，且全部采用侧写和遮挡处理，真正被强调的是人物关系中的权力变化，这也是它能在成年观众中引发持续讨论的原因。",
      "本站已将该剧收录进影视资源库，并整理了分集看点与观剧提示。需要提醒的是，剧集节奏偏慢，前两集信息密度很高，建议一次连续观看以获得完整的情绪铺垫。",
    ],
  },
  {
    id: "n2",
    title: "独立游戏《绯色回廊》发布第二章，叙事分支增加至四十余条",
    summary:
      "小团队用两年时间打磨的文字冒险新作更新第二章。开发者在日志里坦言，最难的不是写分支，而是让每一条分支都值得被走一遍。",
    cover:
      "https://readdy.ai/api/search-image?query=dark%20fantasy%20corridor%20illustration%20with%20crimson%20velvet%20curtains%20and%20golden%20arched%20gateways%2C%20moody%20atmospheric%20lighting%2C%20painterly%20digital%20art%2C%20elegant%20and%20mysterious%20interior&width=640&height=400&seq=news-cover-02&orientation=landscape",
    date: "2026-10-09",
    category: "游戏动态",
    author: "编辑部 · 陈默",
    source: "18禁游戏情报",
    hot: 7460,
    body: [
      "《绯色回廊》是一款以对话和选择驱动的文字冒险游戏，玩家扮演一位在陌生公馆中醒来的访客，通过与不同角色的交谈逐步拼凑出公馆的秘密。第一章在今年三月上线后，凭借克制的美术与克制的文本获得不错的口碑。",
      "本次更新的第二章新增了两条主线入口和四十余条叙事分支，开发团队同时重写了第一章的部分对话，让选择的后果在更早的位置就能被感知。",
      "值得注意的是，游戏提供了完整的跳过与内容分级说明，玩家可以在设置中关闭自己不感兴趣的情节段落，而不影响主线推进。这种设计在同类作品中并不常见。",
      "游戏目前处于抢先体验阶段，官方给出的完整版时间窗口是明年上半年。我们会在后续更新中持续跟进。",
    ],
  },
  {
    id: "n3",
    title: "漫画《夜色标本》单行本第三卷：用分镜讲完一场没有对话的告别",
    summary:
      "第三卷收录了被读者称为「全系列最安静」的六话内容。作者在卷末后记里写到，这一卷他删掉了将近四十页对白。",
    cover:
      "https://readdy.ai/api/search-image?query=still%20life%20of%20vintage%20books%20and%20dried%20dark%20red%20roses%20on%20a%20shadowed%20wooden%20table%2C%20moody%20chiaroscuro%20lighting%2C%20editorial%20photography%2C%20sophisticated%20and%20quiet&width=640&height=400&seq=news-cover-03&orientation=landscape",
    date: "2026-10-06",
    category: "漫画观察",
    author: "编辑部 · 林知",
    source: "18禁漫画档案",
    hot: 6120,
    body: [
      "《夜色标本》是一部黑白为主、局部使用酒红专色的长篇漫画。故事围绕一间只在深夜营业的旧书店展开，每一话由一位客人的来访构成，看似独立，实际共同指向店主自己的过去。",
      "第三卷的六话几乎全部依靠画面推进，对白总量不到前两卷的三分之一。作者用大量的空镜、手部特写和重复构图，把人物的犹豫与克制放进分镜节奏里。",
      "卷末收录了十二页的分镜草稿，可以看到作者反复调整同一场戏的视线方向。对于关注叙事技巧的读者，这部分附赠内容可能比正篇更有意思。",
      "单行本第三卷已在本站资源库收录，附有阅读顺序建议与前三卷的剧情回顾。",
    ],
  },
  {
    id: "n4",
    title: "行业观察：成人内容平台的分级与合规，正在变成一门技术活",
    summary:
      "从年龄验证到内容标注，越来越多平台开始把分级做成一套可执行的产品机制，而不是页面底部的一行免责声明。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20architectural%20interior%20with%20dim%20warm%20lighting%20and%20elegant%20velvet%20seating%2C%20deep%20wine%20red%20and%20amber%20tones%2C%20cinematic%20minimal%20photography%2C%20no%20people&width=640&height=400&seq=news-cover-04&orientation=landscape",
    date: "2026-10-02",
    category: "行业观察",
    author: "编辑部 · 沈屿",
    source: "18禁行业观察",
    hot: 5340,
    body: [
      "过去几年，成人内容平台在合规上的投入明显增加。年龄确认、内容分级标签、敏感场景提示，这些曾经被放在页面角落的说明，如今逐渐成为产品结构的一部分。",
      "一个明显的变化是分级粒度。早期平台往往只区分「成人」与「非成人」，现在则会把题材强度、画面呈现方式、是否包含争议情节分别标注，让用户可以在进入之前就做出判断。",
      "技术层面的挑战在于一致性。人工审核成本高、标准难以统一，纯算法又容易误判，多数平台最终选择两者结合，并保留用户申诉通道。",
      "对创作者来说，清晰的分级规则其实是利好。它让创作边界变得可预期，也减少了作品因标注不当而被误伤的情况。",
    ],
  },
  {
    id: "n5",
    title: "秋季档片单：五部值得关注的成人向电影，以及它们的观看顺序",
    summary:
      "这一季的片单整体偏冷，慢节奏、强氛围的作品占了大半。我们按情绪强度做了排序，方便你按状态选择。",
    cover:
      "https://readdy.ai/api/search-image?query=autumn%20cinema%20screening%20hall%20with%20deep%20red%20velvet%20seats%20and%20soft%20warm%20spotlight%2C%20empty%20and%20quiet%2C%20cinematic%20wide%20shot%2C%20elegant%20atmosphere&width=640&height=400&seq=news-cover-05&orientation=landscape",
    date: "2026-09-28",
    category: "影视资讯",
    author: "编辑部 · 顾青",
    source: "18禁影视观察",
    hot: 8890,
    body: [
      "今年的秋季档没有出现体量特别大的作品，反而是几部中小成本的独立制作更值得留意。它们的共同点是节奏慢、对白少、把大量时间留给环境音和人物独处。",
      "如果只想看一部，我们建议从《无声剧场》开始。它几乎全部发生在同一间剧场里，靠灯光和调度完成叙事，对成年观众的理解力有一定要求，但完成度非常高。",
      "《午夜房间》适合深夜观看，画面偏暖，情绪更柔和；《玻璃玫瑰》则更锋利一些，适合对关系题材感兴趣的观众。",
      "完整片单与每部作品的适看提示已整理进本期专题，可在资源页按「年份 2026」筛选查看。",
    ],
  },
  {
    id: "n6",
    title: "《霓虹档案》公布开放世界新作，主打夜间城市与多线叙事",
    summary:
      "开发团队在发布活动中展示了十二分钟实机画面，城市规模与昼夜系统是本次最大的变化，成人向内容依然保持可选开关。",
    cover:
      "https://readdy.ai/api/search-image?query=retro%20futuristic%20neon%20alley%20illustration%20in%20deep%20burgundy%20and%20warm%20orange%2C%20rain%20and%20reflections%20on%20the%20ground%2C%20moody%20atmosphere%2C%20no%20people%2C%20painterly%20concept%20art&width=640&height=400&seq=news-cover-06&orientation=landscape",
    date: "2026-09-21",
    category: "游戏动态",
    author: "编辑部 · 陈默",
    source: "18禁游戏情报",
    hot: 10240,
    body: [
      "《霓虹档案》系列此前的两作都是线性关卡结构，新作则把舞台扩展成一整座夜间城市。玩家可以在不同街区接取委托，同一条主线的关键事件可能因接取顺序而产生不同结果。",
      "实机演示里最受关注的是昼夜与天气系统，雨天的街道反射和室内灯光形成了强烈的冷暖对比，也直接影响潜行与追逐的玩法判断。",
      "关于成人向内容，团队确认会延续前作的开关设计：核心剧情不依赖相关段落推进，玩家可自行选择是否开启。",
      "发售窗口目前定在明年年底，我们会在后续测试中带来更完整的体验报告。",
    ],
  },
];

export const resourceList: ResourceItem[] = [
  {
    id: "r1",
    name: "暗涌",
    cover:
      "https://readdy.ai/api/search-image?query=elegant%20silhouette%20of%20a%20woman%20in%20a%20long%20evening%20gown%20standing%20behind%20frosted%20glass%2C%20dramatic%20warm%20rim%20light%2C%20film%20noir%20poster%20art%2C%20fully%20clothed%2C%20tasteful%20and%20artistic%2C%20deep%20wine%20red%20tones&width=600&height=800&seq=res-cover-01&orientation=portrait",
    type: "film",
    typeLabel: "影视",
    tags: ["心理惊悚", "剧集", "雨夜", "慢节奏"],
    region: "欧美",
    year: 2026,
    rating: 8.7,
    favorites: 3421,
    summary: "八集心理惊悚剧集，港城的雨夜与一段没有说出口的旧案。全剧亲密场面极少，靠沉默与光影推进。",
    body: [
      "《暗涌》全季八集，单集四十五分钟左右，故事发生在常年下雨的港城。两位主角因一桩十年前的旧案重新接触，在互相试探中逐渐暴露出各自隐瞒的部分。",
      "剧集最大的特点是克制。镜头很少靠近人物面部，大量使用门缝、车窗、楼道这类受限视角，让观众始终处在旁观的位置。配乐几乎缺席，环境音成为主要的情绪来源。",
      "本剧适合喜欢慢节奏、愿意主动拼凑信息的观众。如果你更习惯强情节推进，前两集可能需要一点耐心。",
      "适看提示：包含威胁、跟踪与心理压迫情节，全部以侧写方式呈现。",
    ],
  },
  {
    id: "r2",
    name: "绯色回廊",
    cover:
      "https://readdy.ai/api/search-image?query=dark%20fantasy%20game%20key%20art%20with%20a%20cloaked%20figure%20holding%20a%20lantern%20before%20a%20crimson%20archway%2C%20painterly%20digital%20illustration%2C%20atmospheric%20and%20elegant%2C%20deep%20red%20and%20gold%20palette&width=600&height=800&seq=res-cover-02&orientation=portrait",
    type: "game",
    typeLabel: "游戏",
    tags: ["文字冒险", "多结局", "独立游戏", "哥特"],
    region: "国产",
    year: 2026,
    rating: 8.9,
    favorites: 5180,
    summary: "以对话和选择驱动的文字冒险，四十余条叙事分支，围坐公馆的一夜，逐步拼出主人真正想隐藏的事。",
    body: [
      "《绯色回廊》是一款第一人称文字冒险游戏。玩家扮演在陌生公馆中醒来的访客，需要在有限的夜晚时间里与五位住客交谈，判断谁在说谎。",
      "游戏的核心机制是「记忆碎片」：每次对话中获得的细节会被记录在笔记本里，玩家可以随时把两条碎片组合，从而解锁新的追问选项。",
      "第二章更新后，主线入口增加到四条，结局数量达到十一个。开发团队同时提供了章节跳转功能，方便玩家回头补完分支。",
      "适看提示：题材偏阴暗，包含悬疑与压迫氛围，可在设置中关闭不感兴趣的情节段落。",
    ],
  },
  {
    id: "r3",
    name: "夜色标本",
    cover:
      "https://readdy.ai/api/search-image?query=moody%20comic%20book%20cover%20illustration%20of%20a%20rainy%20city%20street%20at%20night%20rendered%20in%20burgundy%20and%20black%20ink%20tones%2C%20graphic%20novel%20aesthetic%2C%20artistic%20and%20restrained&width=600&height=800&seq=res-cover-03&orientation=portrait",
    type: "comic",
    typeLabel: "漫画",
    tags: ["黑白漫画", "单元剧", "旧书店", "文艺"],
    region: "日本",
    year: 2026,
    rating: 9.1,
    favorites: 4302,
    summary: "只在深夜营业的旧书店，每一话由一位客人的来访构成。黑白画面配酒红专色，第三卷几乎没有对白。",
    body: [
      "《夜色标本》目前已出版三卷，故事围绕一间深夜旧书店展开。店主替客人保管不愿带回家的东西，每一话讲一位客人与一件物品的关系。",
      "画风以黑白为主，局部使用酒红专色标记关键物件，这种限制性的用色让画面非常干净。分镜节奏偏慢，喜欢留白和空镜的读者会很喜欢。",
      "第三卷开始收束前两卷埋下的线索，建议按顺序阅读。单行本每卷末尾都附有作者的分镜草稿。",
      "适看提示：包含成人向情感描写，以隐喻和留白为主。",
    ],
  },
  {
    id: "r4",
    name: "霓虹档案",
    cover:
      "https://readdy.ai/api/search-image?query=cyberpunk%20city%20key%20art%20at%20night%20with%20neon%20signs%20in%20amber%20and%20deep%20red%2C%20rain%20soaked%20streets%2C%20wide%20futuristic%20skyline%2C%20no%20people%2C%20cinematic%20illustration&width=600&height=800&seq=res-cover-04&orientation=portrait",
    type: "game",
    typeLabel: "游戏",
    tags: ["开放世界", "潜行", "赛博", "多线叙事"],
    region: "欧美",
    year: 2027,
    rating: 8.4,
    favorites: 2874,
    summary: "系列首次转向开放世界，一整座夜间城市、动态天气与多线叙事，成人向段落提供独立开关。",
    body: [
      "《霓虹档案》新作把舞台从线性关卡扩展到一座完整的夜间城市。玩家以调查员身份接取街区委托，主线关键事件会因接取顺序不同而改变呈现方式。",
      "天气系统不只是视觉装饰。雨天会放大脚步声，影响潜行判定；雾天则降低视野范围，让追逐变得更容易脱身。这一层设计让城市真正参与玩法。",
      "成人向内容延续前作做法，作为可选段落存在，关闭后不影响主线理解与结局解锁。",
      "目前公布的平台为 PC 与主机，预计明年年底发售。",
    ],
  },
  {
    id: "r5",
    name: "午夜房间",
    cover:
      "https://readdy.ai/api/search-image?query=quiet%20japanese%20style%20room%20at%20dusk%20with%20warm%20paper%20lantern%20light%20and%20the%20shadow%20of%20a%20curtain%2C%20cinematic%20still%2C%20tasteful%20minimal%20interior%20photography%2C%20warm%20amber%20and%20deep%20red%20tones&width=600&height=800&seq=res-cover-05&orientation=portrait",
    type: "film",
    typeLabel: "影视",
    tags: ["文艺", "室内剧", "深夜", "日影"],
    region: "日本",
    year: 2025,
    rating: 8.2,
    favorites: 1960,
    summary: "几乎全部发生在一间公寓里的电影，两个人一整夜的对话，关于告别，也关于谁该先开口。",
    body: [
      "《午夜房间》是一部典型的室内剧，九十分钟里只有两个角色、一个场景。故事从凌晨一点开始，到天亮结束，两人在收拾行李的过程中不断绕回同一个话题。",
      "导演用了大量固定机位，让观众像是在房间的某个角落旁观。灯光的明暗变化成为时间的标记，直到最后一镜才切到窗外。",
      "适合深夜独自观看。如果你喜欢对话密集、情绪细腻的作品，这部值得一看。",
      "适看提示：包含成人向情感描写与吸烟镜头。",
    ],
  },
  {
    id: "r6",
    name: "玻璃玫瑰",
    cover:
      "https://readdy.ai/api/search-image?query=artistic%20portrait%20of%20a%20womans%20profile%20in%20soft%20shadow%2C%20warm%20orange%20rim%20light%20against%20a%20deep%20burgundy%20backdrop%2C%20editorial%20fashion%20photography%2C%20fully%20clothed%2C%20elegant%20and%20restrained&width=600&height=800&seq=res-cover-06&orientation=portrait",
    type: "film",
    typeLabel: "影视",
    tags: ["关系", "悬疑", "韩影", "冷色调"],
    region: "韩国",
    year: 2024,
    rating: 7.9,
    favorites: 1542,
    summary: "一场看似体面的婚姻在三十天内崩塌。剧本把所有的关键信息藏在饭桌与车窗的沉默里。",
    body: [
      "《玻璃玫瑰》以三十天为时间单位，分段记录一对夫妻关系的瓦解过程。每一天都从一顿饭开始，而饭桌上的对话一次比一次短。",
      "影片的叙事技巧在于信息的不对等：观众比其中一方更早知道真相，于是每一个平静的场面都带着压迫感。",
      "摄影偏冷，室内多用自然光，与题材很贴合。结局的处理见仁见智，但不影响前面的完成度。",
      "适看提示：包含关系冲突与心理压迫情节。",
    ],
  },
  {
    id: "r7",
    name: "雾中列车",
    cover:
      "https://readdy.ai/api/search-image?query=steam%20train%20crossing%20a%20misty%20stone%20bridge%20at%20night%2C%20graphic%20novel%20style%20illustration%2C%20deep%20red%20and%20warm%20amber%20palette%2C%20atmospheric%20fog%2C%20no%20text&width=600&height=800&seq=res-cover-07&orientation=portrait",
    type: "comic",
    typeLabel: "漫画",
    tags: ["悬疑", "公路", "黑白", "短篇"],
    region: "日本",
    year: 2025,
    rating: 8.5,
    favorites: 2211,
    summary: "一列永远到不了终点的夜行列车，乘客各自带着不愿提起的行李。八话完结的短篇集。",
    body: [
      "《雾中列车》是一部八话完结的悬疑短篇。列车在雾中反复经过同一座桥，乘客逐渐意识到时间出了问题，而每个人的行李里都藏着一段过去。",
      "作品采用类似舞台剧的结构，八话几乎都在同一节车厢内发生，靠人物站位与窗外景物的细微变化制造不安。",
      "结局收得干净，没有强行解释所有细节。喜欢开放式结尾的读者会比较满意。",
      "适看提示：包含悬疑与轻度惊悚画面。",
    ],
  },
  {
    id: "r8",
    name: "第七夜",
    cover:
      "https://readdy.ai/api/search-image?query=dark%20visual%20novel%20key%20art%20of%20a%20lone%20figure%20on%20a%20rooftop%20under%20a%20crimson%20moon%2C%20painterly%20digital%20illustration%2C%20moody%20and%20atmospheric%2C%20deep%20red%20night%20sky&width=600&height=800&seq=res-cover-08&orientation=portrait",
    type: "game",
    typeLabel: "游戏",
    tags: ["视觉小说", "轮回", "悬疑", "国产"],
    region: "国产",
    year: 2025,
    rating: 8.0,
    favorites: 1733,
    summary: "七个夜晚，七次重置。玩家的每一次选择都会改变下一轮开始时人物的记忆，试着在第七夜之前找到出口。",
    body: [
      "《第七夜》是一款以时间循环为核心的视觉小说。每一轮从同一场停电开始，玩家需要在七个夜晚内查明真相，否则一切重置。",
      "与常见循环题材不同，本作的角色会保留部分前几轮的记忆碎片，这意味着玩家的重复体验会以台词变化的形式被回馈。",
      "游戏共有四个主要结局，其中一个需要在前六轮完成特定组合才能解锁。存档界面提供了轮次速览，方便复盘。",
      "适看提示：包含悬疑、惊悚氛围与成人向话题讨论。",
    ],
  },
  {
    id: "r9",
    name: "无声剧场",
    cover:
      "https://readdy.ai/api/search-image?query=empty%20baroque%20theatre%20interior%20lit%20by%20a%20single%20warm%20spotlight%2C%20deep%20red%20velvet%20curtains%2C%20cinematic%20photography%2C%20quiet%20and%20elegant%2C%20rich%20shadows&width=600&height=800&seq=res-cover-09&orientation=portrait",
    type: "film",
    typeLabel: "影视",
    tags: ["艺术片", "舞台", "欧洲", "长镜头"],
    region: "欧洲",
    year: 2023,
    rating: 8.8,
    favorites: 2650,
    summary: "一座即将拆除的老剧场，一位不肯离开的女演员。全片只有二十七句台词，其余交给灯光与脚步。",
    body: [
      "《无声剧场》的故事发生在一座即将拆除的巴洛克式剧场里。女演员拒绝离开，每晚仍然按旧节目单演出，观众席却始终空着。",
      "影片用长时间的单镜头跟随人物穿过舞台与后台，灯光的变化承担了大部分叙事功能。全片台词只有二十七句。",
      "这是一部需要耐心、也需要一点剧场经验的作品，但如果你愿意进入它的节奏，结尾的十分钟非常动人。",
      "适看提示：包含成人向暗示与情绪压抑场面。",
    ],
  },
];

export const topicList: TopicItem[] = [
  {
    id: "t1",
    title: "你心中的年度最佳成人向剧集是哪一部？",
    summary:
      "今年看得最投入的一部是《暗涌》，节奏慢但完全被抓住了。想听听大家的年度片单，最好附一句推荐理由。",
    tags: ["讨论", "剧集", "推荐"],
    replies: 128,
    views: 5240,
    date: "2026-10-13",
    author: "夜行客",
    body: [
      "年底快到了，想把今年的剧集整理一份片单，所以来问问大家的答案。",
      "我先说自己的：《暗涌》。它好在没有把所有的情绪都推到观众脸上，很多关键信息是靠场景和沉默传达的。看完之后会想在脑子里重新过一遍前两集。",
      "规则很简单：一部作品 + 一句推荐理由，最好说明适合什么状态下看。剧集、电影、动画都可以。",
    ],
  },
  {
    id: "t2",
    title: "成人向游戏的叙事和玩法，真的能平衡吗？",
    summary:
      "玩了几年同类作品，感觉大多数要么叙事很好但玩法很浅，要么玩法扎实但故事只是包装。有没有真正两边都站得住的作品？",
    tags: ["讨论", "游戏", "行业"],
    replies: 96,
    views: 4180,
    date: "2026-10-10",
    author: "手柄半坏",
    body: [
      "最近补完了《绯色回廊》第二章，忽然意识到一个问题：这类型作品的玩法设计往往被叙事需求牵着走，最后变成点几下就推进。",
      "但也有反例，比如把选择做成资源管理的作品，玩家的每一次取舍都会影响后期可用的信息量，那种压力是真实存在的。",
      "想听听大家的看法：你觉得哪种设计更接近「平衡」？有没有具体例子？",
    ],
  },
  {
    id: "t3",
    title: "分级制度下的创作边界，到底应该由谁来定？",
    summary:
      "最近几部作品因为标注问题被下架又恢复，讨论里吵得很凶。我觉得问题可能不在尺度，而在于标注本身不够清晰。",
    tags: ["行业", "讨论", "分级"],
    replies: 214,
    views: 9860,
    date: "2026-10-07",
    author: "沈屿",
    body: [
      "这段时间陆续有几部作品因为分级标注不准确被下架，随后补充标注后恢复。评论区里两种声音都很激烈。",
      "我的观察是，多数争议其实不是「能不能拍」，而是「有没有提前说清楚」。观众反感的是被意外内容冒犯，而不是内容本身存在。",
      "如果平台能提供更细的标注维度，比如题材强度、呈现方式、争议情节提示，创作者和观众之间的信任成本会低很多。",
      "欢迎理性讨论，请避免针对具体创作者的人身攻击。",
    ],
  },
  {
    id: "t4",
    title: "漫画分镜里的情绪，是怎么被「画」出来的？",
    summary:
      "《夜色标本》第三卷几乎没有对白，但情绪特别强。想聊聊分镜、留白、重复构图这些手法，欢迎带例子。",
    tags: ["讨论", "漫画", "技法"],
    replies: 73,
    views: 3120,
    date: "2026-10-04",
    author: "林知",
    body: [
      "我一直觉得漫画的情绪不是靠台词堆出来的，而是靠节奏。翻页的速度、格与格之间的距离、人物的视线方向，这些都在替作者说话。",
      "《夜色标本》第三卷是个很好的例子。同一场戏里，作者连续用了三个几乎一样的构图，只改了人物手的位置，情绪就完全变了。",
      "想请大家分享自己印象最深的分镜处理，不限作品类型。",
    ],
  },
  {
    id: "t5",
    title: "深夜观影的设备与灯光，大家是怎么布置的？",
    summary:
      "换了遮光窗帘之后观感提升非常明显。想开个帖收集一下大家的低成本改造方案，尤其是灯光部分。",
    tags: ["讨论", "设备", "生活"],
    replies: 58,
    views: 2240,
    date: "2026-09-30",
    author: "关灯看片",
    body: [
      "先说我的：遮光窗帘 + 一盏可以调色温的落地灯，色温固定在 2700K 左右，亮度调到最低，屏幕亮度也相应降低。",
      "这样看慢节奏的作品特别舒服，眼睛不容易累。耳机用的是开放式，声场宽一点，环境音丰富的片子差别很明显。",
      "预算有限的话，先把窗帘解决，收益最大。",
    ],
  },
  {
    id: "t6",
    title: "求推荐：氛围感强、节奏慢、不靠台词的作品",
    summary:
      "最近状态不太好，看不了太吵的东西。想要那种画面安静、可以慢慢看的作品，影视漫画游戏都行。",
    tags: ["推荐", "讨论", "慢节奏"],
    replies: 141,
    views: 6370,
    date: "2026-09-26",
    author: "雨天信号",
    body: [
      "如题，最近只想看点安静的。不需要强情节，画面和氛围撑得住就行。",
      "已经看过并且很喜欢的：《无声剧场》《午夜房间》，还有《夜色标本》前两卷。",
      "希望推荐的时候稍微说一下适合什么时间段看，谢谢。",
    ],
  },
];

export const slideList: SlideItem[] = [
  {
    id: "s1",
    detailId: "n1",
    kicker: "本期焦点 · 影视",
    title: "《暗涌》：把紧张感藏进雨声里",
    description:
      "八集心理惊悚剧集上线，全剧几乎不靠台词推进，用受限视角与长段沉默完成叙事。",
    image:
      "https://readdy.ai/api/search-image?query=wide%20cinematic%20still%20of%20a%20rain%20soaked%20city%20street%20at%20night%20with%20deep%20wine%20red%20neon%20reflections%20on%20wet%20asphalt%2C%20mysterious%20elegant%20atmosphere%2C%20high%20detail%2C%20no%20text%2C%20no%20people&width=1600&height=900&seq=hero-slide-01&orientation=landscape",
    tag: "影视资讯",
  },
  {
    id: "s2",
    detailId: "r2",
    kicker: "资源推荐 · 游戏",
    title: "《绯色回廊》第二章：四十条分支的克制叙事",
    description:
      "文字冒险新作更新，记忆碎片与追问机制让每一次对话都值得重来一遍。",
    image:
      "https://readdy.ai/api/search-image?query=dark%20baroque%20hallway%20with%20tall%20crimson%20curtains%20and%20warm%20golden%20light%20pools%20on%20a%20marble%20floor%2C%20cinematic%20wide%20shot%2C%20elegant%20and%20mysterious%2C%20no%20people&width=1600&height=900&seq=hero-slide-02&orientation=landscape",
    tag: "游戏动态",
  },
  {
    id: "s3",
    detailId: "n4",
    kicker: "行业观察",
    title: "分级不是一行免责声明，而是一套产品机制",
    description:
      "从年龄确认到内容标注，平台正在把分级做成可执行的技术方案，边界也因此变得可预期。",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20close%20up%20of%20flowing%20dark%20red%20silk%20fabric%20with%20warm%20amber%20light%20and%20deep%20shadows%2C%20elegant%20texture%2C%20cinematic%2C%20luxurious%2C%20artistic%20background%2C%20no%20text&width=1600&height=900&seq=hero-slide-03&orientation=landscape",
    tag: "行业观察",
  },
];

export const newsCategories = ["全部", "影视资讯", "游戏动态", "漫画观察", "行业观察"];

export const resourceTypes = [
  { key: "film", label: "影视" },
  { key: "game", label: "游戏" },
  { key: "comic", label: "漫画" },
];

export const topicTags = ["全部", "讨论", "推荐", "剧集", "游戏", "漫画", "行业", "分级", "设备", "技法"];

export const siteStats = [
  { label: "收录资讯", value: "1,284", suffix: "篇" },
  { label: "资源条目", value: "963", suffix: "条" },
  { label: "话题讨论", value: "412", suffix: "个" },
  { label: "注册读者", value: "38,000", suffix: "+" },
];